import {apiRequest} from "../Api/ApiRequest";

export function api_deletePortalUserComment(commentId: string) {

  return apiRequest({
    url: `/comments/${commentId}`,
    method: 'delete',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );
}
